(function () {
  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function initCountdown(section) {
    var bar = section.querySelector('[data-joistr-countdown]');
    if (!bar || !bar.dataset.countdownEnd) return;

    var endTime = Date.parse(bar.dataset.countdownEnd);
    var clock = bar.querySelector('[data-countdown-clock]');
    if (!clock || Number.isNaN(endTime)) {
      if (clock) clock.hidden = true;
      return;
    }

    var label = bar.querySelector('[data-countdown-label]');
    var hours = bar.querySelector('[data-countdown-hours]');
    var minutes = bar.querySelector('[data-countdown-minutes]');
    var seconds = bar.querySelector('[data-countdown-seconds]');
    var timerId;

    function updateCountdown() {
      var remaining = endTime - Date.now();
      if (remaining <= 0) {
        window.clearInterval(timerId);
        clock.hidden = true;
        if (label) label.textContent = bar.dataset.countdownExpired || 'This offer has ended';
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      hours.textContent = pad(Math.floor(totalSeconds / 3600));
      minutes.textContent = pad(Math.floor((totalSeconds % 3600) / 60));
      seconds.textContent = pad(totalSeconds % 60);
    }

    updateCountdown();
    timerId = window.setInterval(updateCountdown, 1000);
  }

  function init(section) {
    if (!section || section.dataset.joistrReady) return;
    section.dataset.joistrReady = 'true';
    document.body.classList.add('joistr-template');
    initCountdown(section);

    section.querySelectorAll('[data-joistr-form]').forEach(function (form) {
      form.addEventListener('submit', function () {
        var button = form.querySelector('button[type="submit"]');
        if (!button || button.disabled) return;
        button.setAttribute('aria-busy', 'true');
        button.dataset.originalText = button.textContent;
        button.textContent = 'Adding…';
        window.setTimeout(function () {
          button.removeAttribute('aria-busy');
          button.textContent = button.dataset.originalText || 'Add to cart';
        }, 3000);
      });
    });

  }

  function initStickyBuyBar() {
    var sticky = document.querySelector('[data-joistr-sticky]');
    var offer = document.querySelector('#joistr-offer');
    if (sticky && offer && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-hidden', entries[0].isIntersecting);
      }, { threshold: 0.05 });
      observer.observe(offer);
    }
  }

  document.querySelectorAll('[data-joistr-section]').forEach(init);
  initStickyBuyBar();
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector('[data-joistr-section]'));
    initStickyBuyBar();
  });
})();
